import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Table } from 'primeng/table';
import { Router } from "@angular/router";
import { ConfirmationService, MessageService } from 'primeng/api';
import { LazyLoadEvent } from 'primeng/api';
import { Dropdown } from "primeng/dropdown";
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver/src/FileSaver';
import * as moment from "moment";
import { maxYearFunction } from 'src/app/_helpers/utility';
import { PushNotificationService } from 'src/app/services/push-notification.service';
import { CategoryService } from 'src/app/services/category.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-send-notifications',
  templateUrl: './send-notifications.component.html',
  styleUrls: ['./send-notifications.component.scss'],
  providers: [MessageService, ConfirmationService]
})

export class SendNotificationsComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  errorMessage = '';
  statuses: any[];
  searchBy: any[];
  totalRecords: 0;
  notificationList: any[] = [];
  public item: any[] = [];
  loading: boolean = true;
  paginationOption;
  public lastTableLazyLoadEvent: LazyLoadEvent;
  calvalue: Date;
  ucalvalue: Date;
  dcalvalue: Date;
  yearRange;
  minYear = environment.minYear;
  startDate: Date;
  endDate: Date;
  downloadFlg: boolean;
  downloadNotificationList: any;
  searchby;
  wdcalvalue;
  public hide: boolean = true;
  public sellerCsvFile;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId1", { static: false }) pDropDownId1: Dropdown;
  @ViewChild("pDropDownId2", { static: false }) pDropDownId2: Dropdown;
  @ViewChild("pDropDownId3", { static: false }) pDropDownId3: Dropdown;
  @ViewChild("pDropDownId4", { static: false }) pDropDownId4: Dropdown;
  notificationTypes: any = [];
  notificationStatuses: any = [];
  notificationModules: any = [];
  notificationAppTypes: any = [];
  displayIconDialog: boolean = false;
  selectedIconUrl: string = '';

  constructor(private notificationService: PushNotificationService, private router: Router, private messageService: MessageService, private confirmationService: ConfirmationService, private categoryService: CategoryService) { }

  ngOnInit() {
    this.paginationOption = environment.pagination;
    this.yearRange = this.minYear + ":" + maxYearFunction();
    this.statuses = [
      { label: 'Active', value: true },
      { label: 'In-Active', value: false }
    ];
    this.notificationTypes = [
      { label: 'Push Notification', value: 'push_notification' },
      { label: 'Email', value: 'email' }
    ];
    this.notificationStatuses = [
      { label: 'Delivered', value: 'delivered' },
      { label: 'Pending', value: 'pending' }
    ];

    // this.NotificationModules = [
    //   { label: 'Wallet', value: 'Wallet' },
    //   { label: 'FAP', value: 'FAP' },
    //   { label: 'Tournament', value: 'Tournament' },
    //   { label: 'Contest', value: 'Contest' },
    // ];

    this.notificationAppTypes = [
      { label: 'Player', value: 'Player' },
      { label: 'Academy', value: 'Academy' }
    ];
    this.searchBy = [
      { label: 'Created On', value: "created_at" },
      { label: 'Last Modified On', value: "updated_at" }
    ];
    this.downloadFlg = false;
    //this.getwalletlist();
    // this.getCategory();
    this.getNotificationModules();
  }
  
  getNotificationModules() {
    const query = `?filterByParentCategory=NotificationModule`;
    this.categoryService.getCategoryList(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      const notificationModules = data?.data?.items;
      notificationModules.forEach(ele => {
        this.notificationModules.push({ label: ele.name, value: ele.name });
      })
    })
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = '';
    this.dt.filter('', 'notificationType', 'contains');
    this.dt.filter('', 'scheduleDate', 'dateIs');
    this.dt.filter('', 'description', 'contains');
    this.dt.filter('', 'subject', 'contains');
    this.dt.filter('', 'status', 'contains');
    this.dt.filter('', 'sentStatus', 'contains');
    this.dt.filter('', 'created_at', 'dateIs');
    this.dt.filter('', 'createdby', 'contains');
    this.dt.filter('', 'updated_at', 'dateIs');
    this.dt.filter('', 'updatedby', 'contains');
    this.calvalue = null;
    this.ucalvalue = null;
    this.dcalvalue = null;
    this.wdcalvalue = null;
    this.pDropDownId1.clear(null);
    this.pDropDownId2.clear(null);
    this.pDropDownId3.clear(null);
    this.pDropDownId4.clear(null);
    if (this.pDropDownId1) {
      this.pDropDownId1.value = null;
    }
    if (this.pDropDownId2) {
      this.pDropDownId2.value = null;
    }
    if (this.pDropDownId3) {
      this.pDropDownId3.value = null;
    }
    if (this.pDropDownId4) {
      this.pDropDownId4.value = null;
    }
  }

  loadNotifications(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query = "filterByDisable=false";
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = (event.first / event.rows) + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }

    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    if (event.filters != undefined && event.filters["notificationType"] != undefined) {
      params += "&filterByType=" + event.filters["notificationType"].value;
    }
    if (event.filters != undefined && event.filters["description"] != undefined) {
      params += "&filterByDescription=" + event.filters["description"].value;
    }
    if (event.filters != undefined && event.filters["subject"] != undefined) {
      params += "&filterBySubject=" + event.filters["subject"].value;
    }
    if (event.filters != undefined && event.filters["status"] != undefined) {
      params += "&filterByStatus=" + event.filters["status"].value;
    }
    if (event.filters != undefined && event.filters["sentStatus"] != undefined) {
      params += "&filterBySentStatus=" + event.filters["sentStatus"].value;
    }
    if (event.filters != undefined && event.filters["created_at"] != undefined) {
      const createdAt = moment(event.filters["created_at"].value).format("YYYY-MM-DD");
      params += "&filterByCreatedAt=" + createdAt;
    }
    if (event.filters != undefined && event.filters["createdby"] != undefined) {
      params += "&filterByCreatedby=" + event.filters["createdby"].value;
    }
    if (event.filters != undefined && event.filters["updated_at"] != undefined) {
      const createdAt = moment(event.filters["updated_at"].value).format("YYYY-MM-DD");
      params += "&filterByUpdatedAt=" + createdAt;
    }
    if (event.filters != undefined && event.filters["updatedby"] != undefined) {
      params += "&filterByUpdatedby=" + event.filters["updatedby"].value;
    }

    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.notificationService.getBulkNotification(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        if (this.downloadFlg === true) {
          this.exportExcelSheet(data.data || data);
        } else {
          this.loading = false;
          // Handle both response structures: {data: {items, totalCount}} or {data: [...], totalCount}
          if (data.data && Array.isArray(data.data.items)) {
            this.notificationList = data.data.items;
            this.totalRecords = data.data.totalCount;
          } else if (Array.isArray(data.data)) {
            this.notificationList = data.data;
            this.totalRecords = data.totalCount;
          } else {
            this.notificationList = [];
            this.totalRecords = 0;
          }
        }
      },
      err => {
        this.loading = false;
        this.errorMessage = err.error.message;
        console.error('API Error:', err);
      });
  }

  async findImageByBase(base, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].file === base) {
        index = i;
        break;
      }
    }
    return index;
  }


  func(prop, val) {
    var jsonStr = '{"' + prop + '":"' + val + '"}';
    return JSON.parse(jsonStr);
  }

  addNewNotification() {
    this.router.navigate(['/manage/push-notification/send-notification/add']);
  }

  editNotification(id) {
    this.router.navigate(['/manage/push-notification/send-notification/edit/' + id]);
  }

  duplicateNotification(id) {
    this.router.navigate(['/manage/push-notification/send-notification/duplicate/' + id]);
  }

  deleteNotification(data) {
    this.confirmationService.confirm({
    message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to delete this record ?
      </p>
    `,
      // message: 'Are you sure you want to delete this image ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
    rejectLabel: 'Cancel',
      // ❌ Remove icons
    acceptIcon: '',
    rejectIcon: '' , 
      accept: () => {
        var disableStatus;
        if (data.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }
        var updatedata = '{"disable":' + disableStatus + '}';
        this.notificationService.updateBulkNotification(data.id, updatedata).pipe(takeUntil(this.destroy$)).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Send Notification Deleted', life: 3000 });
            setTimeout(()=>{
              this.loadNotifications(this.lastTableLazyLoadEvent);
            },1000);
          },
          err => {
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        //this.getUserDetails(user.id);
      }
    });
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.notificationList.length; i++) {
      if (this.notificationList[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  }

  changeStatus(data) {
    this.confirmationService.confirm({
      // message: 'Are you sure you want to change the status of  ' + (this.titlecasePipe.transform(data.name)) + '?',
          message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to change this status ?
      </p>
    `,
 
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
    rejectLabel: 'Cancel',
      // ❌ Remove icons
    acceptIcon: '',
    rejectIcon: '' , 

      accept: () => {

        var updateData = '{"status":' + data.status + '}';
        this.notificationService.updateBulkNotification(data.id, updateData).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Send Notification Status Updated', life: 3000 });
            setTimeout(()=>{
              this.loadNotifications(this.lastTableLazyLoadEvent);
            },1000);
          },
          err => {
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        this.loadNotifications(this.lastTableLazyLoadEvent);
      }
    });
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadNotifications(this.lastTableLazyLoadEvent);
  }

  exportExcelSheet(notificationList) {
    var propertiesRemove = ['id', 'updatedby', 'description', 'icon', 'subject', 'emailContent', 'disable', 'status', 'created_by'];
    this.downloadNotificationList = notificationList;
    this.downloadNotificationList.forEach(function (item) {
      propertiesRemove.forEach(function (prop) {
        delete item[prop];
      });
    });
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.downloadNotificationList);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, "Bulk_Notification");
    });
  }


  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

  /**
   * Use to add more columns in the table.
  */
  addColumns() {
    this.hide = false;

  }

  /**
  * Use to remove more columns in the table.
  */
  removeColumns() {
    this.hide = true;
  }

  viewIconFullSize(iconUrl: string) {
    this.selectedIconUrl = iconUrl;
    this.displayIconDialog = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
